import { TPartnerAudience, TPartnerDoorService } from "./MarketingContent";

export type TMarketingPartner = {
    name: string;
    logoUrl: string | null;
};

export type TPartnerLinkHosts = {
    valuationBaseUrl: string;
    legalQuoteBaseUrl: string;
    probateReportBaseUrl: string;
};

export const partnerDoorHref = (
    service: TPartnerDoorService,
    audience: TPartnerAudience,
    introducerId: string,
    hosts: TPartnerLinkHosts,
    conveyancingQuoteUrl?: string,
): string => {
    const introducer = `introducer_id=${encodeURIComponent(introducerId)}`;

    if (service === "conveyancing_quote" && conveyancingQuoteUrl !== undefined) {
        return conveyancingQuoteUrl;
    }

    if (service === "valuation") {
        return audience === "adviser"
            ? `${hosts.probateReportBaseUrl}/probate/property-report?${introducer}`
            : `${hosts.valuationBaseUrl}/valuation/your-details?${introducer}`;
    }

    return audience === "client"
        ? `${hosts.legalQuoteBaseUrl}/legal/quote?${introducer}&view=client`
        : `${hosts.legalQuoteBaseUrl}/legal/quote?${introducer}`;
};
